import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import Yup from '_zari/validation/_yup'

import { Button, Form, Modal } from '_zari/core'

import * as SociosSeguimientoService from 'services/sociosSeguimiento.service'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  comentario: Yup.string()
    .min(1)
    .max(500)
    .required()
})

const NuevoDetalleSeguimientoModal = ({ handleClose, show, idSeguimiento, onCreate, modalData = {} }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      comentario: modalData.comentario || ''
    }),
    [modalData]
  )

  const submitHandler = async data => {
    if (modalData._id) {
      SociosSeguimientoService.actualizarDetallexId(idSeguimiento, modalData._id, data)
        .then(() => {
          __zariContext.snack('success', 'El detalle se ha actualizado.')
          if (onCreate) {
            onCreate()
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      SociosSeguimientoService.nuevoDetalle(idSeguimiento, data)
        .then(() => {
          __zariContext.snack('success', 'El detalle se ha creado.')
          if (onCreate) {
            onCreate()
          }
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    }
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>{modalData._id ? 'EDITAR DETALLE SEGUIMIENTO' : 'NUEVO DETALLE SEGUIMIENTO'} </Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.ComentarioFormGroup iError={errors.comentario} iTouched={touched.comentario} fIsSubmitting={isSubmitting} />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Guardar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoDetalleSeguimientoModal
